










































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class InfinityTable extends Vue {
  //#region Computed

  // 主视图的列定义内容
  get columns(): any[] {
    return this.columnDefs.filter((col) => !col.fixed).map((col) => ({
      ...col,
      $style: {
        flex: `1 0 ${col.width || this.defaultWidth}px`,
        width: `${col.width || this.defaultWidth}px`,
      },
    }))
  }

  // 主视图的列总宽度
  get columnsWidth(): number {
    return this.columns
      .map((x) => x.width || this.defaultWidth)
      .reduce((w1, w2) => w1 + w2, 0)
  }

  // 是否显示左侧固定布局
  get showLeftFixed(): boolean {
    return Boolean(this.leftColumnDefs.length)
  }

  // 左侧固定布局的列定义内容
  get leftColumnDefs(): any[] {
    return this.columnDefs
      .filter((col) => col.fixed && col.fixed === 'left')
      .map((col) => ({
        ...col,
        $style: {
          flex: `1 0 ${col.width || this.defaultWidth}px`,
          width: `${col.width || this.defaultWidth}px`,
        },
      }))
  }

  // 左侧固定布局的总宽度
  get colFixedLeftWidth(): number {
    return this.leftColumnDefs
      .map((x) => x.width || this.defaultWidth)
      .reduce((w1, w2) => w1 + w2, '0')
  }

  // 是否显示右侧固定布局
  get showRightFixed(): boolean {
    return Boolean(this.rightColumnDefs.length)
  }

  // 右侧固定布局的列定义内容
  get rightColumnDefs(): any[] {
    return this.columnDefs
      .filter((col) => col.fixed && col.fixed === 'right')
      .map((col) => ({
        ...col,
        $style: {
          flex: `1 0 ${col.width || this.defaultWidth}px`,
          width: `${col.width || this.defaultWidth}px`,
        },
      }))
  }

  // 右侧固定布局的总宽度
  get colFixedRightWidth(): number {
    return this.rightColumnDefs
      .map((x) => x.width || this.defaultWidth)
      .reduce((w1, w2) => w1 + w2, 0)
  }

  // 视图高度
  get viewHeight(): number {
    return this.data.length * this.rowHeight
  }

  // 是否显示底部合计
  get showSummary(): boolean {
    return this.summary !== false
  }

  //#endregion Computed

  //#region Data

  // $refs declare
  public $refs!: {
    thead: HTMLElement
    theadLeft: HTMLElement
    theadRight: HTMLElement
    theadMiddle: HTMLElement
    theadMiddleWrapper: HTMLElement
    tfoot: HTMLElement
    tfootLeft: HTMLElement
    tfootRight: HTMLElement
    tfootMiddle: HTMLElement
    tfootMiddleWrapper: HTMLElement
    tbody: HTMLElement
    tbodyLeft: HTMLElement
    tbodyRight: HTMLElement
    tbodyMiddle: HTMLElement
    tbodyLeftScroll: HTMLElement
    tbodyRightScroll: HTMLElement
    tbodyMiddleScroll: HTMLElement
    tbodyLeftView: HTMLElement
    tbodyRightView: HTMLElement
    emptyContainer: HTMLElement,
  }

  // 表格高度
  @Prop({ default: 600 })
  private height!: number

  // 表格数据
  @Prop({ default: () => [] })
  private data!: any[]

  // 列定义集合
  @Prop({ required: true })
  private columnDefs!: any[]

  // 行高
  @Prop({ default: 38 })
  private rowHeight!: number

  // 默认列宽
  @Prop({ default: 100 })
  private defaultWidth!: number

  // 是否需要鼠标悬浮高亮
  @Prop({ default: false })
  private hover!: boolean

  // 显示合计
  @Prop({ default: false })
  private summary!: boolean

  // 空数据的文案
  @Prop({ default: '暂无数据' })
  private emptyText!: string

  // 可视数据
  private rowData: any[] = []
  // 可见行数
  private visibleCount: number = 0
  // 当前悬浮行的下标
  private hoverIndex: any = null
  // 记录距离顶部滚动偏移量
  private recordScrollTop: number = 0
  // 记录距离左边滚动偏移量
  private recordScrollLeft: number = 0
  // requestAnimationFrame loop
  private loop: number = 0
  // timer
  private timer: number = 0
  // 合计数据项
  private summaryData: { [key: string]: any } = {}

  //#endregion Data

  //#region Lifecycle

  // mounted
  public mounted(): void {
    this.renderTable()
  }

  //#endregion Lifecycle

  //#region Methods

  /**
   * 渲染表格
   */
  public renderTable(): void {
    this.$nextTick(() => {
      this.getVisibleRowCount()
      this.calculateTotal()
      this.updateRenderRowIndex()
      this.setBodyStyle()
      this.setEmptyStyle()
      this.setSpacing()
      this.setScrollListener()
    })
  }

  /**
   * 设置间距(滚动条的间距)
   */
  public setSpacing(): void {
    setTimeout(() => {
      // 垂直
      const { tbodyLeft, tbodyMiddle, tbodyRight } = this.$refs
      const { offsetHeight, clientHeight } = tbodyMiddle
      tbodyLeft.style.marginBottom = `${offsetHeight - clientHeight}px`
      tbodyRight.style.marginBottom = `${offsetHeight - clientHeight}px`

      // 水平
      const { thead, tbody, tfoot } = this.$refs
      const paddingRight = tbody.offsetWidth - tbody.clientWidth
      thead.style.paddingRight = `${paddingRight}px`
      tfoot.style.paddingRight = `${paddingRight}px`
    }, 0)
  }

  /**
   * 设置空数据区域样式
   */
  public setEmptyStyle(): void {
    if (this.$refs.emptyContainer) {
      this.$refs.emptyContainer.style.minWidth = `${this.columnsWidth}px`
    }
  }

  /**
   * 设置表格样式
   */
  public setBodyStyle(): void {
    const { thead, tbody, tfoot } = this.$refs
    const { tbodyLeft, tbodyRight } = this.$refs
    const { tbodyLeftView, tbodyRightView } = this.$refs
    tbody.style.overflowY = this.data.length ? 'auto' : 'hidden'
    tbody.scrollTop = 0
    tbodyLeftView.style.width = `${this.colFixedLeftWidth}px`
    tbodyLeftView.style.height = `${this.viewHeight}px`
    tbodyRightView.style.width = `${this.colFixedRightWidth}px`
    tbodyRightView.style.height = `${this.viewHeight}px`
    tbody.style.height = `${this.height - thead.clientHeight}px`
    tbody.style.height = `${tbody.clientHeight - tfoot.clientHeight}px`
    tbody.style.top = thead ? `${thead.clientHeight}px` : '0'
    tbodyLeft.style.height = this.data.length ? 'auto' : '100%'
    tbodyRight.style.height = this.data.length ? 'auto' : '100%'
    this.showLeftFixed
      ? tbodyLeft.classList.add('border')
      : tbodyLeft.classList.remove('border')
    this.showRightFixed
      ? tbodyRight.classList.add('border')
      : tbodyRight.classList.remove('border')
    this.renderHorizontalScrollbar()
    this.setFixedStyle()
  }

  /**
   * 鼠标移入
   * @param {string} index
   */
  public onMouseEnter(index: number): void {
    if (this.hover === false) {
      return
    }
    this.hoverIndex = index
  }

  /**
   * 鼠标移出
   */
  public onMouseLeave(): void {
    if (this.hover === false) {
      return
    }
    this.hoverIndex = null
  }

  /**
   * 获取视图内显示行数
   */
  private getVisibleRowCount(): void {
    const { thead } = this.$refs
    const visibleHeight = this.$el.clientHeight - thead.clientHeight
    const count = visibleHeight / this.rowHeight
    this.visibleCount = Math.ceil(count) || this.data.length
  }

  /**
   * 设置滚动监听事件
   */
  private setScrollListener(): void {
    this.$refs.tbody.onscroll = (ev) => {
      this.$refs.tbodyMiddle.style.height = 'auto'
      requestAnimationFrame(this.onVerticalScroll)
    }
    this.$refs.tbodyMiddle.onscroll = (ev) => {
      requestAnimationFrame(this.onHorizontalScroll)
    }
  }

  /**
   * 垂直滚动事件
   */
  private onVerticalScroll(): void {
    const { scrollTop } = this.$refs.tbody

    if (scrollTop !== this.recordScrollTop) {
      this.recordScrollTop = scrollTop
      this.updateRenderRowIndex()
      this.renderHorizontalScrollbar()
    }
  }

  /**
   * 水平滚动事件
   */
  private onHorizontalScroll(): void {
    const { theadMiddle, tfootMiddle, tbodyMiddle } = this.$refs
    const { scrollLeft } = tbodyMiddle

    if (scrollLeft !== this.recordScrollLeft) {
      this.recordScrollLeft = scrollLeft
      theadMiddle.style.transform = `translate3d(-${scrollLeft}px, 0, 0)`
      tfootMiddle.style.transform = `translate3d(-${scrollLeft}px, 0, 0)`
      this.setFixedStyle()
    }
  }

  /**
   * 渲染水平滚动条
   */
  private renderHorizontalScrollbar(): void {
    const { tbodyMiddle, tbody } = this.$refs
    const { scrollTop } = this.$refs.tbody

    // Delay setting height for render horizontal scrollbar
    window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => {
      tbodyMiddle.style.height = `${tbody.clientHeight + scrollTop}px`
    }, 500)
  }

  /**
   * 设置固定列的样式
   */
  private setFixedStyle(): void {
    const { theadLeft, theadRight } = this.$refs
    const { tfootLeft, tfootRight } = this.$refs
    const { tbodyLeft, tbodyRight, tbodyMiddle } = this.$refs
    const { scrollLeft } = tbodyMiddle

    if (scrollLeft > 0) {
      theadLeft.classList.add('scrolling')
      tfootLeft.classList.add('scrolling')
      tbodyLeft.classList.add('scrolling')
    } else {
      theadLeft.classList.remove('scrolling')
      tfootLeft.classList.remove('scrolling')
      tbodyLeft.classList.remove('scrolling')
    }

    if (scrollLeft + tbodyMiddle.clientWidth < tbodyMiddle.scrollWidth) {
      theadRight.classList.add('scrolling')
      tbodyRight.classList.add('scrolling')
      tfootRight.classList.add('scrolling')
    } else {
      theadRight.classList.remove('scrolling')
      tbodyRight.classList.remove('scrolling')
      tfootRight.classList.remove('scrolling')
    }
  }

  /**
   * 更新所有需要显示行数的下标数组
   */
  private updateRenderRowIndex(): void {
    this.rowData = []
    const startIndex = Math.floor(this.recordScrollTop / this.rowHeight)
    const endIndex = startIndex + this.visibleCount
    for (let index = startIndex; index <= endIndex; index++) {
      if (this.data[index]) {
        const translateY = index * this.rowHeight
        this.rowData.push(
          Object.freeze({
            ...this.data[index],
            $index: index,
            $style: { transform: `translate3d(0, ${translateY}px ,0)` },
          }),
        )
      }
    }
  }

  /**
   * 计算合计
   */
  private calculateTotal(): void {
    this.columnDefs.map((col) => {
      if (col.summary !== undefined) {
        this.$set(this.summaryData, col.filed, col.summary)
      } else {
        const summary = this.data
          .map((d) => d[col.filed])
          .reduce((d1, d2) => parseFloat(d1) + parseFloat(d2), 0)
        const summaryVal =
          isNaN(summary) || !this.data.length ? 'N/A' : summary.toFixed(2)
        this.$set(this.summaryData, col.filed, summaryVal)
      }
    })
  }

  //#endregion Methods
}
